import { Box } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledDataRoutingFormContainer = styled(Box)`
  &&& {
    align-items: flex-start;
    justify-content: space-between;
    overflow-x: auto;
    padding: var(--cl-space-5) var(--cl-space-6);
    gap: var(--cl-space-14);
  }
`;

export const StyledLeftColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 44%;
  gap: var(--cl-space-4);
`;

export const StyledRightColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 47%;
  gap: var(--cl-space-4);
`;

export const StyledSpacer = styled.div`
  flex-grow: 1;
`;

export const StyledCategoryContainer = styled.div`
  display: grid;
  border: 1px solid var(--cl-gray-300);
  border-radius: var(--cl-radius-2);
  padding: 15px;
  grid-template-columns: 1fr 2fr auto;
`;

export const CategoryInfo = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--cl-space-1);
`;

export const StyledPre = styled.pre`
  font-family: var(--cl-font-family-mono);
  font-size: var(--cl-font-size-2);
  font-weight: var(--cl-font-weight-regular);
  margin-bottom: 0;
  margin-top: 0;
  flex-shrink: 0;
`;

export const StyledRoutingServiceName = styled(StyledPre)<{
  serviceSelected: boolean;
}>`
  color: ${({ serviceSelected }) => (serviceSelected ? 'var(--cl-green-500)' : 'var(--cl-text-default)')};
`;

export const RouteActions = styled.div`
  display: flex;
  gap: var(--cl-space-3);
`;
